import api from './api';
import { Gift, Clock, Zap, Star } from 'lucide-react';

const popupCampaignService = {
  // Récupérer la campagne popup active
  getActiveCampaign: async (userId = null) => {
    try {
      const params = userId ? { user_id: userId } : {};
      const response = await api.get('/popup/active/', { params });
      return response.data;
    } catch (error) {
      console.error('Error fetching active popup campaign:', error);
      throw error;
    }
  },

  // Suivre les interactions avec le popup
  trackInteraction: async (campaignId, interactionType) => {
    try {
      const response = await api.post('/popup/track/', {
        campaign_id: campaignId,
        type: interactionType // 'click' ou 'close'
      });
      return response.data;
    } catch (error) {
      console.error('Error tracking popup interaction:', error);
      throw error;
    }
  },

  // Lister toutes les campagnes (admin)
  getAllCampaigns: async () => {
    try {
      const response = await api.get('/popup/campaigns/');
      const campaigns = response.data;
      const formattedCampaigns = campaigns.map(campaignData => {
        if (!campaignData) return null;

        console.log('Formatage de la campagne:', campaignData);

        // Mapper les types d'icônes
        const iconMap = {
          'gift': 'Gift',
          'clock': 'Clock', 
          'zap': 'Zap',
          'star': 'Star'
        };

        // Importer l'icône correspondante
        const getIconComponent = (iconType) => {
          console.log('Récupération de l\'icône pour:', iconType);
          switch (iconType) {
            case 'gift':
              return Gift;
            case 'clock':
              return Clock;
            case 'zap':
              return Zap;
            case 'star':
              return Star;
            default:
              return Gift;
          }
        };

        const formatted = {
          id: campaignData.id,
          title: campaignData.title,
          subtitle: campaignData.subtitle || "Ne manquez pas cette opportunité !",
          description: campaignData.description,
          features: campaignData.features || [],
          backgroundImage: campaignData.background_image,
          icon: getIconComponent(campaignData.icon_type),
          displayDelay: campaignData.display_delay,
          displayDuration: campaignData.display_duration,
          frequencyHours: campaignData.frequency_hours,
          timer: campaignData.timer,
          buttons: campaignData.buttons,
          campaignType: campaignData.campaign_type,
          statistics: campaignData.statistics
        };

        console.log('Campagne formatée:', formatted);
        return formatted;
      });
      return formattedCampaigns;
    } catch (error) {
      console.error('Error fetching popup campaigns:', error);
      throw error;
    }
  },

  // Formater les données de campagne pour le composant Popup
  formatCampaignForPopup: (campaignData) => {
    if (!campaignData) return null;

    console.log('Formatage de la campagne:', campaignData);

    // Mapper les types d'icônes
    const iconMap = {
      'gift': 'Gift',
      'clock': 'Clock', 
      'zap': 'Zap',
      'star': 'Star'
    };

    // Importer l'icône correspondante
    const getIconComponent = (iconType) => {
      console.log('Récupération de l\'icône pour:', iconType);
      try {
        switch (iconType) {
          case 'gift':
            return Gift;
          case 'clock':
            return Clock;
          case 'zap':
            return Zap;
          case 'star':
            return Star;
          default:
            return Gift;
        }
      } catch (error) {
        console.error('Erreur lors du chargement de l\'icône:', error);
        return Gift; // Fallback
      }
    };

    const formatted = {
      id: campaignData.id,
      title: campaignData.title,
      subtitle: campaignData.subtitle || "Ne manquez pas cette opportunité !",
      description: campaignData.description,
      features: campaignData.features || [],
      backgroundImage: campaignData.background_image,
      icon: getIconComponent(campaignData.icon_type),
      displayDelay: campaignData.display_delay,
      displayDuration: campaignData.display_duration,
      frequencyHours: campaignData.frequency_hours,
      timer: campaignData.timer,
      buttons: campaignData.buttons,
      campaignType: campaignData.campaign_type,
      statistics: campaignData.statistics
    };

    console.log('Campagne formatée:', formatted);
    return formatted;
  },

  // Vérifier si le popup doit être affiché
  shouldShowPopup: (campaignData, lastPopupTime) => {
    if (!campaignData) return false;

    const now = new Date().getTime();
    const frequencyMs = campaignData.frequencyHours * 60 * 60 * 1000;

    // Si jamais affiché ou si la fréquence est passée
    if (!lastPopupTime || (now - parseInt(lastPopupTime)) > frequencyMs) {
      return true;
    }

    return false;
  },

  // Sauvegarder le timestamp du dernier popup
  saveLastPopupTime: () => {
    localStorage.setItem('lastPopupCampaign', new Date().getTime().toString());
  },

  // Récupérer le timestamp du dernier popup
  getLastPopupTime: () => {
    return localStorage.getItem('lastPopupCampaign');
  },

  // Effacer le timestamp du dernier popup
  clearLastPopupTime: () => {
    localStorage.removeItem('lastPopupCampaign');
  }
};

export default popupCampaignService;
